import { JsonProperty } from "@outfoxx/jackson-js";

export class Group {
    @JsonProperty()
    id?: number;
    @JsonProperty()
    count?: number;
    @JsonProperty()
    name: string;
    @JsonProperty()
    svgContent: string;
    @JsonProperty()
    svgMap: string;
    @JsonProperty()
    fillColor: string;
    @JsonProperty()
    imgContent: string;
    @JsonProperty()
    imgMap: string;
}
